import { useEffect, useState } from "react";

export const useIsTouchDevice = () => {
	const [isTouchDevice, setIsTouchDevice] = useState(false);

	useEffect(() => {
		const isTouchDevice =
			"ontouchstart" in window ||
			navigator.maxTouchPoints > 0 ||
			(navigator as unknown as { msMaxTouchPoints: number }).msMaxTouchPoints >
				0;
		setIsTouchDevice(isTouchDevice);
	}, []);

	return isTouchDevice;
};
